import { createContext, useContext, useCallback, useState } from "react";
import { getSessionToken, setSessionToken, clearSessionToken } from "./session.js";

// React-level session boundary. session.js stays the low-level sessionStorage
// holder (apiClient.js reads it directly for request headers, no React
// needed there). This context exists so RouteGuard/AppShell re-render the
// moment a token is set or cleared, instead of only reflecting the change
// on the next full page refresh.

const SessionContext = createContext(null);

export function SessionProvider({ children }) {
  const [token, setToken] = useState(() => getSessionToken());

  const signIn = useCallback((nextToken) => {
    setSessionToken(nextToken);
    setToken(nextToken);
  }, []);

  const signOut = useCallback(() => {
    clearSessionToken();
    setToken(null);
  }, []);

  const value = { isAuthenticated: Boolean(token), signIn, signOut };

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

/** Read session state and sign-in/sign-out actions. Only valid inside SessionProvider. */
export function useSession() {
  const session = useContext(SessionContext);
  if (!session) {
    throw new Error("useSession must be used within SessionProvider");
  }
  return session;
}
